import { render, staticRenderFns } from "./ot-danger-modal.vue?vue&type=template&id=3123813f&scoped=true&"
import script from "./ot-danger-modal.vue?vue&type=script&lang=ts&"
export * from "./ot-danger-modal.vue?vue&type=script&lang=ts&"
import style0 from "./ot-danger-modal.vue?vue&type=style&index=0&id=3123813f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3123813f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VDivider,VIcon})
